import TreatmentDialog from './TreatmentDialog';

export default TreatmentDialog;
